import {
  CHANGE_AUTO_SYNC,
  EMainLayoutType,
  EMainViewMode,
  EPhrasesColumnTab,
  EPhrasesColumnType,
  EPlayMode,
  IGeneralActions,
  IGeneralState,
  SET_APP_SETTINGS,
  SET_AUDIO_PLAYER_STATE,
  SET_AUTH_USER,
  SET_AUTO_PAUSE_SIZE,
  SET_HOVER_AUTO_PAUSE,
  SET_LIBRARY_GROUP,
  SET_MAIN_VIEW_MODE,
  SET_ONE_TIME_TOOLTIP,
  SET_PAUSE_ON_NOTE,
  SET_PLAY_MODE,
  SET_PLAYER_RATE,
  SET_ROUTE_ON_LOGIN,
  SET_SHOW_NATIVE_CAPTIONS,
  SET_SHOW_TRANSLATIONS,
  SET_SNACKBAR_PANEL,
  SET_VIDEO_WATCH_TODAY,
  SYNC_USER_LOCAL_STORAGE,
  UPDATE_GENERAL
} from './types';
import { Reducer } from 'redux';
import { AudioPlayerStates } from '../../types/common';

const initialGeneralState: IGeneralState = {
  autoPause: 0,
  autoSync: true,
  hoverAutoPause: false,
  authUser: null,
  libraryGroupId: null,
  audioPlayerState: AudioPlayerStates.PAUSED,
  playerRate: 1,
  playMode: EPlayMode.DEFAULT,
  snackbarPanel: {
    show: false,
    text: ''
  },
  oneTimeTooltip: {
    showPhrasesEditTooltip: false,
    showNativeLanguageTooltip: false,
    showNativeAvailableTooltip: true,
    showTutorialPopup: true,
    showTutorialTooltip: true,
    showSaveForMagicTooltip: true,
    showSavedForMagicTooltip: false,
    showTranslations: true,
    showFullscreen: true,
    showSelectionTip: true,
  },
  mainViewMode: EMainViewMode.CALL,
  mainLayout: {
    phrasesColumn: EPhrasesColumnType.COLUMNS_1,
    phrasesColumnTab: EPhrasesColumnTab.TRANSLATED,
    phrasesColumnTabPrev: EPhrasesColumnTab.TRANSLATED,
    showLeftPanel: true,
    type: EMainLayoutType.COLUMNS_4
  },
  showNativeCaptions: false,
  appSettings: {
    statServersUrl: '',
    saveUserTranslations: false
  },
  pauseOnNote: false,
  videoWatchToday: null,
  routeOnLogin: null,
  useShortcuts: true,
};

const getInitialGeneralState = (): IGeneralState => {
    const state: IGeneralState = {...initialGeneralState};
    return state;
}

export const generalReducer: Reducer<IGeneralState, IGeneralActions> = (
    state= getInitialGeneralState(),
    action
) => {

    switch (action.type) {
      case SYNC_USER_LOCAL_STORAGE:
        return {
          ...state,
          autoPause: action.data.autoPause,
          mainLayout: {
            ...state.mainLayout,
            phrasesColumn: action.data.phrasesColumn,
            showLeftPanel: action.data.showLeftPanel,
            type: action.data.mainLayoutType
          }
        }
        case CHANGE_AUTO_SYNC:
            return {
                ...state,
                autoSync: action.state
            };
        case SET_AUTH_USER:
            return {
                ...state,
                authUser: action.user
            };
        case SET_AUTO_PAUSE_SIZE:
            return {
                ...state,
                autoPause: action.pause
            }
        case SET_LIBRARY_GROUP:
            return {
                ...state,
                libraryGroupId: action.groupId ? +action.groupId : null
            }
      case SET_AUDIO_PLAYER_STATE:
            return {
              ...state,
              audioPlayerState: action.state
            }
        case SET_PLAYER_RATE:
            return {
                ...state,
                playerRate: action.rate
            }
        case SET_PLAY_MODE:
            return {
                ...state,
                playMode: action.mode
            }
      case SET_HOVER_AUTO_PAUSE:
        return { ...state, hoverAutoPause: action.hoverAutoPause }
      case SET_ONE_TIME_TOOLTIP:
        return {
          ...state,
          oneTimeTooltip: {
            ...state.oneTimeTooltip,
            ...action.value,
          }
        }
      case SET_MAIN_VIEW_MODE:
        return { ...state, mainViewMode: action.mainViewMode }
      case SET_SHOW_NATIVE_CAPTIONS:
        return { ...state, showNativeCaptions: action.show }
      case SET_SNACKBAR_PANEL:
        return {
          ...state,
          snackbarPanel: {
            show: action.show,
            text: action.text
          }
        }
      case SET_APP_SETTINGS:
        return {
          ...state,
          appSettings: {
            ...state.appSettings,
            ...action.value
          }
        }
      case SET_PAUSE_ON_NOTE:
        return { ...state, pauseOnNote: action.pauseOnNote }

      case SET_ROUTE_ON_LOGIN:
        return {
          ...state,
          routeOnLogin: {
            ...state.routeOnLogin,
            ...action.data,
          }}

      case SET_VIDEO_WATCH_TODAY:
        return {
          ...state,
          videoWatchToday: action.videoWatchToday
        }

      case SET_SHOW_TRANSLATIONS:
        return {
          ...state,
          showTranslations: action.value,
        }

      case UPDATE_GENERAL:
        return {
          ...state,
          ...action.value,
        }

      default:
        return state;
    }
};
